import { render, staticRenderFns } from "./Widget.vue?vue&type=template&id=753b3cfc&scoped=true"
import script from "./Widget.vue?vue&type=script&lang=js"
export * from "./Widget.vue?vue&type=script&lang=js"
import style0 from "./Widget.styl?vue&type=style&index=0&id=753b3cfc&prod&scoped=true&lang=stylus&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "753b3cfc",
  null
  
)

export default component.exports